'use strict';

var GridToolbarDemandTransparencyDirective = function GridToolbarDemandTransparencyDirective() {
  return {
    restrict: 'E',
    replace: true,
    require: '^rmGridPanel',
    template: require('../templates/grid-toolbar-demand-transparency.html')
  };
};
GridToolbarDemandTransparencyDirective.$inject = [];
module.exports = GridToolbarDemandTransparencyDirective;